// Iconslider

// Flickity
var Flickity = require('flickity')
import 'flickity/css/flickity.css'


// Flickity is instanciated in the HTML
if ( $('.fig-icon-slider .gallery').length ) {

  var $iconslider = $('.fig-icon-slider')
  var $iconsliderControls = $iconslider.find('.slider-controls li')


  // Init Flickity
  var $gallery = new Flickity( '.fig-icon-slider .gallery' , {
    pageDots: false
  });


  // Control Slider with Icons
  $iconsliderControls.click(function() {
    var index = $(this).index()
    $gallery.select( index )
  })


  // Active State on Icons
  $gallery.on( 'cellSelect', function() {
      var previousSelectedButton = $('.slider-controls').find('.active');
      var selectedButton = $('.slider-controls').children().eq( $gallery.selectedIndex )

      previousSelectedButton.removeClass('active')
      selectedButton.addClass('active')
    });

}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_icon-slider.js